import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/reverse-mortgage-calculator',
  component: () => import('../../routes/ReverseMortgageCalculator.svelte'),
  card: {
    id: 'reverse-mortgage',
    title: 'Reverse Mortgage',
    description: 'Calculate how much you can borrow with a reverse mortgage. See your maximum loan amount, line of credit, and year-by-year loan balance growth.',
    icon: 'home',
    iconBgClass: 'bg-amber-50',
    iconTextClass: 'text-amber-600',
    href: '/reverse-mortgage-calculator',
    category: 'Real Estate',
  },
  seo: {
    title: 'Reverse Mortgage Calculator – Maximum Borrowing Amount & HECM Calculator',
    description: 'Free reverse mortgage calculator. Calculate how much home equity you can unlock with a HECM reverse mortgage. See maximum loan amount, monthly disbursements, and year-by-year balance growth.',
  },
};

export default meta;